<template>
  <v-app class="desktop-warning">
    <v-main class="main-wrapper">
      <div class="fixed-layout">
        <div class="left">
          <div class="text-content">
            <div class="ops">
              {{ t("desktopWarning.ops") }}
            </div>

            <div class="main-message">
              {{ $t("desktopWarning.mainMessage") }}
            </div>

            <div class="sub-message">
              {{ $t("desktopWarning.subMessage") }}
            </div>
          </div>
        </div>

        <div class="right">
          <div class="phone-wrapper">
            <div class="circle-bg"></div>

            <div class="idea-rays">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <v-img
              src="@/assets/images/desktop_phone.png"
              width="280"
              class="phone-image"
              contain
            />
          </div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();
</script>

<style scoped lang="scss">
  .desktop-warning {
    background-color: #131416;
    min-height: 100vh;
    display: flex;
  }

  .main-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
  }

  .fixed-layout {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    width: fit-content;
    max-width: 1200px;

    transform: translateY(-10vh);
  }

  /* ---------------- LEFT SIDE ---------------- */
  .left {
    max-width: 520px;
  }

  .text-content {
    color: #f0f0f0;
  }

  .ops {
    font-size: clamp(18px, 1.5vw, 24px);
    font-weight: bold;
    margin-bottom: 12px;
  }

  .main-message {
    font-size: clamp(26px, 2.8vw, 34px);
    font-weight: bold;
    margin-bottom: 18px;
    white-space: nowrap;
  }

  .sub-message {
    font-size: clamp(18px, 2vw, 24px);
    opacity: 0.8;
    line-height: 1.4;
  }

  /* ---------------- RIGHT SIDE ---------------- */
  .right {
    display: flex;
    justify-content: center;
  }

  .phone-wrapper {
    position: relative;
    width: clamp(220px, 25vw, 300px);
    height: clamp(220px, 25vw, 300px);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(5vh);
  }

  .circle-bg {
    position: absolute;
    width: 75%;
    height: 73%;
    background-color: #2b2b2b;
    border-radius: 50%;
    clip-path: inset(0 0 28% 0);
    right: -18%;
    top: 88%;
    transform: translateY(-50%);
    z-index: 0;
  }

  .phone-image {
    position: relative;
    z-index: 1;
    width: 75%;
  }

  /* ---------------- IDEA RAYS ---------------- */
  .idea-rays {
    position: absolute;
    top: -2%;
    left: 8%;
    z-index: 2;
    transform: rotate(-50deg);
  }

  .idea-rays span {
    position: absolute;
    width: 4px;
    height: 20px;
    background-color: #89898a;
    border-radius: 5px;
  }

  /* raio central */
  .idea-rays span:nth-child(1) {
    transform: rotate(0deg);
    left: 20px;
  }

  /* raio esquerdo */
  .idea-rays span:nth-child(2) {
    transform: rotate(-35deg);
    left: 2px;
    top: 7px;
  }

  /* raio direito */
  .idea-rays span:nth-child(3) {
    transform: rotate(35deg);
    left: 37px;
    top: 7px;
  }
</style>
